import { Link } from 'react-router-dom';

interface Comic {
  id: string;
  title: string;
  slug: string;
  author: string;
  category: string;
  rating: number;
  cover: string;
  status: string;
  chapters: number;
  views: number;
  tags: string[];
}

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 border border-background-200/60 transition-all duration-300 hover:border-accent-300">
        <div className="relative aspect-[3/4] overflow-hidden">
          <img
            src={comic.cover}
            alt={comic.title}
            title={`${comic.title} - 韩漫画网韩国漫画`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute top-2 left-2">
            <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
              comic.status === '连载中'
                ? 'bg-accent-500/90 text-background-50'
                : 'bg-foreground-600/80 text-background-50'
            }`}>
              {comic.status}
            </span>
          </div>
          <div className="absolute top-2 right-2">
            <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-background-50/80 text-foreground-700 whitespace-nowrap">
              {comic.rating} ★
            </span>
          </div>
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent h-20"></div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors duration-200 line-clamp-1">
            {comic.title}
          </h3>
          <div className="flex items-center justify-between mt-1.5">
            <span className="text-xs text-foreground-500">{comic.author}</span>
            <span className="text-xs text-foreground-400">{comic.chapters}话</span>
          </div>
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {comic.tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}